import styles from "./Icons.module.css";

export  function IconFull() {
	return (
		<>
			<div className={styles.iconFull}></div>
			
		</>
	);
}

export  function IconEmpty() {
	return (
		<>
			
			<div className={styles.iconEmpty}></div>
		</>
	);
}
